import { useCallback, useContext } from "react";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { ICreateUserBookingParams } from "../domain";
import { apiServiceContext } from "../../api-service-context";
import { EntityType } from "../query-keys";

export const useCreateBooking = (options?: UseMutationOptions<any, any, ICreateUserBookingParams>) => {
  const { bookingApiService } = useContext(apiServiceContext);
  const queryClient = useQueryClient();

  const mutationFn = useCallback(
    (payload: ICreateUserBookingParams) =>
      bookingApiService.createCancellableRequest((cancelToken) =>
        bookingApiService.createUserBooking(payload, cancelToken)
      ),
    [bookingApiService]
  );

  const mutation = useMutation<any, any, ICreateUserBookingParams>(mutationFn, {
    ...options,
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries(EntityType.BOOKING_OF_USER);
      options?.onSuccess?.(...args);
    },
  });

  return mutation;
};
